export class Permission {
    roleType: string;
    target: string;
    isAdmin?: boolean;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/permission.ts